import { translations as coreTranslations } from '@festina-life/core'

import { dk } from './dk'
import { en } from './en'
import { nl } from './nl'

export const translations = {
  'en-GB': {
    ...coreTranslations['en-GB'],
    ...en,
  },
  'nl-NL': {
    ...coreTranslations['nl-NL'],
    ...nl,
  },
  'da-DK': {
    ...coreTranslations['da-DK'],
    ...dk,
  },
} as const
